import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
export var StyledWrapper = styled(motion.div)(function (_ref) {
  var error = _ref.error,
    theme = _ref.theme;
  return {
    '& input': {
      padding: '0 !important'
    },
    '& .MuiInputBase-root': {
      color: error ? theme.palette.error.main : null
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline': {
      borderColor: error ? theme.palette.error.main : null
    },
    '& .MuiTouchRipple-root': {
      display: 'none'
    }
  };
});
export var StyledTextField = styled(TextField)(function (_ref2) {
  var edges = _ref2.edges,
    required = _ref2.required,
    showError = _ref2.showError,
    size = _ref2.size,
    theme = _ref2.theme,
    value = _ref2.value,
    variant = _ref2.variant;
  return {
    margin: 0,
    '& .MuiInputBase-root': {
      padding: size === 'small' ? theme.spacing(1, 8, 1, 2) + " !important" : theme.spacing(3, 8, 3, 4) + " !important",
      border: variant === 'filled' ? "2px solid transparent" : null,
      borderRadius: function borderRadius() {
        switch (edges) {
          case 'rounded':
            return 99;
          case 'sharp':
            return 0;
          default:
            return theme.shape.borderRadius;
        }
      }
    },
    '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: required && !value || showError ? theme.palette.secondary.main : null
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.grey.transparent
    },
    '& .Mui-focused': {
      border: variant === 'filled' ? "2px solid " + (required && !value ? theme.palette.secondary.main : theme.palette.primary.main) : null
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: required && !value ? theme.palette.secondary.main : null
    },
    '& input': {
      padding: '0 !important'
    }
  };
});